﻿﻿export interface IUpdateClusterSwapManager {
    clusterId: number;
    swapManager: string;
    chainId: number;
    updateAllClustersInChain: boolean;
}
